<div class="wrapper__contentComponent--expediente container my-5">
  <!-- Main panel -->
  <ng-container *ngIf="listFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Lista de bases de conicimiento</h2>
      <button
        id="crearBaseConocimiento"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="crearBaseConocimiento()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Crear una base de conocimiento
      </button>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <p class="justify-text">
        Una base de conocimiento (KB, por sus siglas en inglés "Knowledge Base")
        es un sistema estructurado que almacena, organiza y gestiona información
        sobre un dominio o varios dominios relacionados, permitiendo su
        recuperación y uso para la toma de decisiones, resolución de problemas o
        generación de respuestas inteligentes.
      </p>
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="input-group w-50">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          [(ngModel)]="searchTerm" />
        <span class="input-group-text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16">
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.098zm-5.442 1.398a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z" />
          </svg>
        </span>
      </div>
    </div>
    <!-- Tabla de basesConocimiento -->
    <div
      class="table-container"
      *ngIf="basesConocimiento.length > 0; else noData">
      <table class="table table-striped table-bordered">
        <thead class="custom-header">
          <tr>
            <th>Nombre</th>
            <th class="display-none">Estado</th>
            <th class="display-none">Fecha Modificación</th>
            <th class="display-none">Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let baseConocimiento of basesConocimiento
                | filter: searchTerm : 'Nombre'
                | paginate: { itemsPerPage: 5, currentPage: currentPage }
            "
            class="hover-effect">
            <td>{{ baseConocimiento.Nombre }}</td>
            <td class="display-none">{{ baseConocimiento.Estado }}</td>
            <td class="display-none">
              {{
                baseConocimiento.FechaModificacion | date: 'yyyy-MM-dd HH:mm'
              }}
            </td>
            <td class="display-none">
              {{ baseConocimiento.UsuarioModificacion }}
            </td>
            <td class="btns-box">
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="onRowClick(baseConocimiento)">
                Ver
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="editarBaseConocimiento(baseConocimiento)">
                Editar
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="eliminarBaseConocimiento(baseConocimiento.Id)">
                Eliminar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination Controls -->
      <pagination-controls
        (pageChange)="currentPage = $event"
        previousLabel="Anterior"
        nextLabel="Siguiente"
        class="d-flex justify-content-center mt-3">
      </pagination-controls>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noData>
      <div class="no-data-container">
        <p>{{ mensaje }}</p>
      </div>
    </ng-template>
  </ng-container>
  <!-- Read panel -->
  <ng-container *ngIf="readFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Formulario de base de conocimiento</h2>
      <button
        id="detalleBaseConocimiento"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="volverElemento()">
        <span class="govco-svg govco-arrow-circle-left me-2"></span>
        Volver a elemento
      </button>
    </div>
    <!-- Formulario panel -->
    <form [formGroup]="baseConocimientoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div *ngFor="let field of nomDesForm" class="col-md-{{ field.width }}">
          <div class="mb-3">
            <label [for]="field.name" class="form-label"
              >{{ field.label
              }}<span
                *ngIf="field.required"
                _ngcontent-ng-c3465959523=""
                class="text-danger">
                *</span
              ></label
            >
            <!-- Text Input -->
            <input
              *ngIf="field.type === 'text'"
              [id]="field.name"
              [type]="field.type"
              class="form-control"
              [formControlName]="field.name"
              [readonly]="isReadOnly" />
            <!-- Textarea -->
            <textarea
              *ngIf="field.type === 'textarea'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              rows="3"
              [readonly]="isReadOnly"></textarea>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let option of estados" [value]="option">
                {{ option }}
              </option>
            </select>
            <!-- Validation Error Messages -->
            <div *ngIf="getErrorMessage(field.name)" class="text-danger">
              {{ getErrorMessage(field.name) }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex gap-2">
        <button
          type="button"
          class="btn-govco fill-btn-govco"
          (click)="toggleEdit()"
          *ngIf="isReadOnly">
          Editar
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco"
          *ngIf="!isReadOnly">
          Guardar
        </button>
        <button
          type="button"
          class="btn-govco btn-govco"
          (click)="toggleEdit()"
          *ngIf="!isReadOnly">
          Cancelar
        </button>
      </div>
    </form>
    <!-- Formulario de dominios -->
    <div class="d-flex justify-content-between align-items-center mb-3 mt-5">
      <h4 class="title-section">Lista de dominios relacionados</h4>
      <button
        id="relacionarDominio"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="relacionarDominio()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Relacionar dominio
      </button>
    </div>
    <!-- Tabla de dominios -->
    <div class="table-container" *ngIf="dominios.length > 0; else noData">
      <table class="table table-striped table-bordered">
        <thead class="custom-header">
          <tr>
            <th>Nombre</th>
            <th class="display-none">Estado</th>
            <th class="display-none">Fecha Modificación</th>
            <th class="display-none">Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dominio of dominios" class="hover-effect">
            <td>{{ dominio.Nombre }}</td>
            <td class="display-none">{{ dominio.Estado }}</td>
            <td class="display-none">
              {{ dominio.FechaModificacion | date: 'yyyy-MM-dd HH:mm' }}
            </td>
            <td class="display-none">{{ dominio.UsuarioModificacion }}</td>
            <td>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="desvincularDominio(dominio.Id)">
                Desvincular
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noData>
      <div class="no-data-container">
        <p>La base de conocimiento no dispone de dominios relacionados.</p>
      </div>
    </ng-template>
  </ng-container>
</div>
<div *ngIf="modalNDFlag">
  <app-modal-nom-des
    [elements]="basesConocimiento"
    (ndEmitter)="registrarBaseConocimiento($event)">
  </app-modal-nom-des>
</div>
<div *ngIf="modalEleFlag">
  <app-modal-selec-ele (elementoEmitter)="registrarDominio($event)">
  </app-modal-selec-ele>
</div>
